import fs from "fs/promises";
import path from "path";

import { generateTypesFromEnvx } from "../../src/utils/generateTypesFromEnvx";
import { parseEnvx } from "../../src/core/parser";
import { fillMissingSchemaEntries } from "../../src/utils";
import { createMetaJsonFile, writeFileEnsureDir } from "../utils";
import { META_JSON_FILE_NAME } from "../../shared/constants";
import { logger } from "../../shared/logger";
import { green } from "colorette";

export async function types(
  options: {
    input: string;
    typesOutput: string;
    metaFilePath: string;
  },
  loggerOptions?: {
    showPrefix?: boolean;
    addSpace?: string;
  }
) {
  try {
    const inputPath = path.resolve(process.cwd(), options.input);
    const outputPath = path.resolve(process.cwd(), options.typesOutput);
    const outputPath_relativePath = path.relative(process.cwd(), outputPath);

    const content = await fs.readFile(inputPath, "utf-8");
    const { env, schema: parsedSchema } = parseEnvx(content);

    const fullSchema = fillMissingSchemaEntries(env, parsedSchema);

    const typesContent = generateTypesFromEnvx(fullSchema);
    // [DEPRECATED] await fs.writeFile(outputPath, typesContent);
    await writeFileEnsureDir(outputPath, typesContent);

    const metaFilePath = path.join(
      options.metaFilePath || ".",
      META_JSON_FILE_NAME
    );
    await createMetaJsonFile(fullSchema, metaFilePath);

    logger.success(
      `TypeScript types created   → ${green(outputPath_relativePath)}`,
      loggerOptions
    );
    logger.success(
      `Meta JSON schema generated   → ${green(
        path.relative(process.cwd(), metaFilePath)
      )}`,
      loggerOptions
    );
  } catch (err) {
    logger.error(`Error generating types: ${err.message || err}`);
    process.exit(1);
  }
}
